module.exports = __webpack_public_path__ + "img/rank-wrapper--diamond-director-bg.ac18f380.jpg";